import { BREAKPOINTS } from '~/config/breakpoints'

const CONFIG = {
    CART_ID: 'cart_id',
    CUSTOMER_TOKEN: 'customer_token',
    PRODUCT_PAGE_PREFIX: 'p',
    CATEGORY_PAGE_PREFIX: 'c',
    SEARCH_PAGE_PREFIX: 's',
    URL_CUSTOMER_PREFIX: 'customer',
    PRODUCT_PAGE: 'productPage',
    CATEGORY_PAGE: 'categoryPage',
    WISHLIST_PAGE: 'wishlistPage',
    CART_PAGE: 'cartPage',
    BRAND_BBK: 'home&you',
    URL_CART: '/checkout/cart',
    URL_SUCCESS: '/success',
    URL_LOGIN_PAGE: '/auth/login',
    URL_LOGIN_SUCCESS: '/customer/account',
    URL_REGISTER_PAGE: '/register',
    URL_RESET_PASSWORD_PAGE: '/resetpassword',
    URL_WISHLIST: '/wishlist',
    URL_CUSTOMER_WISHLIST: '/customer/wishlist',
    URL_ADDRESSES: 'addresses',
    URL_FORGOT_PASSWORD_PAGE: '/forgotPassword',
    URL_USER_DASHBOARD: '/customer',
    URL_CUSTOMER_ORDERS: '/customer/orders',
    URL_CUSTOMER_ADDRESSES: '/customer/addresses',
    URL_CUSTOMER_ADDRESSES_CREATE: '/customer/addresses/create',
    URL_CUSTOMER_ADDRESSES_UPDATE: '/customer/addresses/update',
    URL_CUSTOMER_NEWSLETTER: '/customer/newsletter',
    URL_CUSTOMER_ORDERS_RATE: '/customer/orders/rate',
    URL_CUSTOMER_ORDERS_INCIDENT: '/customer/orders/incident',
    URL_CUSTOMER_MY_DATA: '/customer/my-data',
    URL_MARKETPLACE: 'marketplace/shop/view/id',
    URL_CHECKOUT_CART: '/checkout/cart',
    URL_MEDIA_SWATCH: 'https://home-you.com/media/attribute/swatch',
    URL_AUTH_PREFIX: '/auth',
    ACCOUNT_PREFIX: 'auth',
    STORE_LOCATOR_PREFIX: 'adresy-sklepow',
    BREAKPOINTS: {
        [BREAKPOINTS.xxs]: 320,
        [BREAKPOINTS.xs]: 480,
        [BREAKPOINTS.sm]: 640,
        [BREAKPOINTS.md]: 768,
        [BREAKPOINTS.lg]: 1024,
        [BREAKPOINTS.xl]: 1280,
        [BREAKPOINTS['2xl']]: 1536,
    },
    GRID_SIZE_MOBILE: {
        small: 1,
        medium: 2,
        large: 4,
    },
    GRID_SIZE_DESKTOP: {
        small: 2,
        medium: 3,
        large: 6,
    },
    IS_NAVIGATION_PLUGIN_ENABLED: false,
    CURRENCY_SYMBOL_PLN: 'PLN',
    CURRENCY_SYMBOL_ZL: 'zł',
    PAGE_SIZE: 90,
    PRODUCTS_ON_PAGE: [30, 60, 90],
    ERROR_CART: 'CART_ERRORS',
    CMS_BLOCK_GLOBAL_TOP_BANNER: 'global_content_top_banner',
    HEADER_LANGS: {
        name: 'store',
        list: { pl: 'pl', en: 'en', ru: 'ru' },
    },
    PRICE_RANGE_INCREMENTED: 1,
    CAROUSEL_TYPES: {
        defaultCategory: 'defaultCategory',
        otherSeries: 'otherSeries',
    },
    PRODUCT_TYPES: {
        simple: 'Product',
        grouped: 'ProductGrouped',
        configurable: 'ProductConfigurable',
    },
    PRODUCT_CONFIGURABLE_ATTRIBUTE_COLOR: 'shade_colour',
    PRODUCT_CONFIGURABLE_ATTRIBUTE_COLOR_ALGOLIA_LABEL: 'Kolor',
    PRODUCT_CONFIGURABLE_URL: 'color',
    NEW_PRODUCTS_CATEGORIES: ['Mzg3NQ=='],
}
export default defineAppConfig(CONFIG)

type ConfigType = typeof CONFIG
declare module '@nuxt/schema' {
    interface AppConfigInput extends ConfigType {}
}
